var flktyMainList = [];
var flktyNavList = [];

function initializeCarousel() {
  if (window.matchMedia("(min-width: 768px)").matches) {
    // Loop through each carousel group (assuming each group is wrapped)
    document.querySelectorAll('.cl_inner_tabs').forEach(function(wrapper, index) {
      var main = wrapper.querySelector('.carousel-main');
      var nav = wrapper.querySelector('.carousel-nav');

      if (main && !main.classList.contains('flickity-enabled')) {
        var flktyMain = new Flickity(main, {
          pageDots: false,
          fade: true,
          wrapAround: false,
          draggable: false
        });
        flktyMainList.push(flktyMain);
      }

      if (nav && !nav.classList.contains('flickity-enabled')) {
        var flktyNav = new Flickity(nav, {
          asNavFor: main,
          contain: true,
          pageDots: false,
          prevNextButtons: false,
          draggable: true,
          wrapAround: false
        });
        flktyNavList.push(flktyNav);
      }
    });

  } else {
    // Destroy all instances
    flktyMainList.forEach(f => f.destroy());
    flktyNavList.forEach(f => f.destroy());
    flktyMainList = [];
    flktyNavList = [];
  }
}

initializeCarousel();
window.addEventListener('resize', initializeCarousel);
$('.template-collection-virtual-headucator .cl_tab_content_wp').hide().find('.cl_tab_content_wrapper').removeClass('hiden_first');

// green popup js
$('body').on('click','.quick-svg',function(e){
    $('.quick-svg.is-open').removeClass('is-open'); 
    $('.quick_popup.is-open').removeClass('is-open'); 
    $('.product-featured-image').removeClass('is-open');
    $(this).parents('.product-featured-image').addClass('is-open');
    let ancestor = $(this).closest('product-card');
    if (ancestor.length > 0) {
      ancestor.find('.quick_popup').addClass('is-open');
    }
});

$('body').on('click','.quick_popup_close',function(e){
  e.preventDefault();
  $(this).parents('.quick_popup').removeClass('is-open');
  $(this).parents('.product-card').find('.product-featured-image').removeClass('is-open');
});

// temporary js
$('body').on('click','.cl_black_btn',function(e){
  $('.head_popup').addClass('is-open');
});

$('body').on('click','.quick_popup_close',function(e){
  $('.head_popup').removeClass('is-open');
});

// product page accordion 
 $('.desc_heading').click(function() {
    $('.desc_heading').removeClass('active');
    $('.desc_content').slideUp();
    if (!$(this).next().is(':visible')) {
        $(this).next().slideDown();
        $(this).addClass('active');
    }
});
$('.headucator_faq_title').click(function() {
    $('.headucator_faq_title').removeClass('active');
    $('.headucator_info').slideUp();
    if (!$(this).next().is(':visible')) {
        $(this).next().slideDown();
        $(this).addClass('active');
    }
});

// grab tab js
$(".cl_tabs_button, .cl_close_block").click(function() {
  var $clCollectionInner = $(this).closest('.cl_collection_inner');
  var $clTabViewWp = $clCollectionInner.find(".cl_tab_view_wp");
  var isOpen = $clTabViewWp.hasClass("is-open");
  var breakpoint = 768;

  if ($(window).width() < breakpoint) {
    if (isOpen) {
      $clCollectionInner.removeClass("is-open");
      $clTabViewWp.removeClass("is-open").slideUp();
    } else {
      $clCollectionInner.addClass("is-open");
      $clTabViewWp.addClass("is-open").slideDown();
    }
  } else {
    if (isOpen) {
      $clCollectionInner.removeClass("is-open");
      $clTabViewWp.removeClass("is-open").animate({
        width: "toggle",
        opacity: 0
      });
    } else {
      $clCollectionInner.addClass("is-open");
      $clTabViewWp.addClass("is-open").animate({
        width: "toggle",
        opacity: 1
      });
    }
  }
  
});


// option menu js
$(".gear_btn, .activity_btn, .helmetsize_btn").click(function(){
  $(this).parent().toggleClass("is-open");
  $('.head_popup').removeClass('is-open');
});

$(".gear_select_ul li").click(function(){
  var currentele = $(this).html();
  $(".gear_btn li").html(currentele);
  $(this).parents(".tab_gear_btns, .activity_btns_wpr").removeClass("is-open");
});

var selectedValues = {};

$('body').on('click','.cl_tab_gear_main ul.gear_select_ul li a',function(e){
  e.preventDefault();
  var tab_txt = $(this).text();    
  var tab_txt_type = $(this).attr('data-gear');    
  var tab_collection = $(this).attr('data-collection');    
  $('.cl_inner_tabs').hide();
  $('.cl_inner_tabs[data-tab="'+tab_txt_type+'"]').show();
  $(this).parents('.cl_tab_gear_main').find('a.gear_btn').text(tab_txt).addClass('active');
  $('.cl_right_collection_inner').show();
  $('p.choose_gear').hide();
  $('.sidebar-filter').removeClass('disable');
  $('.carousel-cell.is-nav-selected').removeClass('active');
  $('.cl_inner_tabs[data-tab="'+tab_txt_type+'"]').removeClass('select_first_tab');
  $('.carousel-main-only-text_wpr,.cl_carousel_tabs').addClass('active');
  $('.sidebar-filter_new.sidebar-filter_secound .sidebar-filter-cstep').trigger('click');
  $('.carousel-cell').each(function(){
      var text_u = $(this).find('.cl_carousel-cell h6');
      $(this).find('.cl_carousel_col').removeClass('select_tab_val')
      var text_tab = text_u.attr('data-tab-name');
      text_u.html(text_tab)    
  });
  $('.activity_btns_wpr a').each(function() {
    var title = $(this).data('title');
    if (title) {
      $(this).text(title);
    }
  });
  $('.visor_option_col input[type="radio"]').prop('checked', false);
  // 🔄 Refresh Flickity
  flktyMainList.forEach(f => {
    f.reloadCells();
    f.resize();
  });
  flktyNavList.forEach(f => {
    f.reloadCells();
    f.resize();
  });
  
  var url = 'https://www.craniologie.com/collections/'+tab_collection;
  window.history.pushState("", "", url);
   fetch('/collections/'+tab_collection+'?section_id=main-collection-product-grid-virtual')
  .then((response) => response.text())
  .then((responseText) => {
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const newGrid = html.querySelector('#ProductGridContainer');
    if (newGrid) {
      document.querySelector('#ProductGridContainer').innerHTML = newGrid.innerHTML;
    } else {
      console.warn('ProductGridContainer not found in fetched HTML');
    }
  })
  .catch((error) => {
    console.error('Fetch error:', error);
  });
selectedValues = {};
  
//  var paramsup = {
//   method: 'GET',
//   url: url, // URL to request the data from
//   success: function(data) { 
//     // Create a temporary DOM element to parse the HTML response
//     var parser = new DOMParser();
//     var doc = parser.parseFromString(data, 'text/html');
//     var grid = doc.querySelector('#ProductGridContainer').innerHTML; // Extract the HTML content for the product grid
    
//     // Replace the content of the ProductGridContainer
//     var productGridContainer = document.querySelector('#ProductGridContainer');
//     productGridContainer.innerHTML = grid; // Replace the existing content
//   },
//   error: function() {
//     console.error("Error loading the content.");
//   }
// };
//   // Create the XMLHttpRequest object
// var xhr = new XMLHttpRequest();
// xhr.open(paramsup.method, paramsup.url, true);

// // Set up the callback function
// xhr.onload = function() {
//   if (xhr.status === 200) {
//     paramsup.success(xhr.responseText);
//   } else {
//     paramsup.error();
//   }
// };

// // Send the request
// xhr.send();

//     return false;
  
});


$('body.template-collection-virtual-headucator').on('click','.cl_tabs .tab_item.first',function(e){
  e.preventDefault();
  $('.tab_item').removeClass('active');
  $(this).addClass('active');  
  $('.template-collection-virtual-headucator .cl_tab_content_wp').show();
  $('p.choose_gear').show();
  $('.sidebar-filter').addClass('disable');
  $('.cl_inner_tabs').removeClass('disable').addClass('select_first_tab');
  $('.cl_right_collection_inner').hide();
  $('.sidebar-filter_new.sidebar-filter_secound').find('.sidebar-filter-arrow').trigger('click');
  $('body').removeClass('unselect_step');
  $('.carousel-main-only-text_wpr,.cl_carousel_tabs').removeClass('active');
  $('.carousel-cell.is-nav-selected').addClass('active');
  var gear_txt = $('.cl_tab_gear_main').find('a.gear_btn').attr('data-title')
  $('.cl_tab_gear_main').find('a.gear_btn').text(gear_txt).removeClass('active disable');  
});

$('body').on('click','.cl_shop_inner_tabs a',function(){
    var cur_type = $(this).attr('data_main_type');
    $('.cl_shop_inner_tabs .shop_tab_link').removeClass('active');
    $(this).addClass('active');
    $('.cl_category_main,.cl_shop_text').hide();
    $('.cl_category_main[data-type-cat="'+cur_type +'"]').show();
});
$('body').on('click','.tab_item.shop_look',function(){
    $('.tab_item').removeClass('active');
    $(this).addClass('active');  
    $('.template-page-shop-by-look .cl_tab_content_wp').slideDown();
});
// mobile accodian

if ($(window).width() < 768) {
    $('.cl_carousel_mob_title').click(function() {
        $('.cl_carousel_mob_title').removeClass('active');
        $('.cl_carousel_info').slideUp();
        if (!$(this).next().is(':visible')) {
            $(this).next().slideDown();
            $(this).addClass('active');
        }
    });
}


$('body').on('click','.sidebar-filter_new .sidebar-filter-cstep',function(e){
  $(this).toggleClass('active');
  $(this).parents('.sidebar-filter_new').find('.sidebar-filter_info').slideToggle();
  $(".sidebar-filter_new").removeClass("is-open");
  $(this).parents('.sidebar-filter_new').toggleClass('is-open');
});

$('body').on('click','.sidebar-filter-arrow',function(e){
  $(".sidebar-filter_new").removeClass("is-open");
  $(this).parents('.sidebar-filter_new').find('.sidebar-filter-cstep').removeClass('active');
  $(this).parents('.sidebar-filter_new').find('.sidebar-filter_info').slideUp();
});



// product grid open
$('body').on('click','.cl_category_slide_custom',function(e){
  var $parentSliderCol = $(this).closest('.cl_category_slider_col');
  $parentSliderCol.find('.cl_category_slide_info').removeClass('is-open');
  $parentSliderCol.find('.cl_category_slide').removeClass('active');
 
  var carousel_cell = $(this).parents('.swiper-slide').attr('data-block-id'); 
  if($parentSliderCol.find('.cl_category_product.active[data-block-content="'+ carousel_cell+'"]').length > 0){
    $('.cl_category_product').slideUp().removeClass('active');
  }else{
    $(this).next('.cl_category_slide_info').addClass('is-open');
    $(this).parents('.cl_category_slide').addClass('active');
    $('.cl_category_product').slideUp().removeClass('active');
    $parentSliderCol.find('.cl_category_product[data-block-content="'+ carousel_cell+'"]').slideDown().addClass('active');
  }
});
$('body').on('click','.cl_category_close',function(e){
  var $parentSliderCol = $(this).closest('.cl_category_slider_col');
  $parentSliderCol.find('.cl_category_slide_info').removeClass('is-open');
  $(this).removeClass('is-open');
  $parentSliderCol.find('.cl_category_slide').removeClass('active');
  $(this).parents('.cl_category_product').slideUp();
});
  

// product grid open popup
$('body').on('click','.cl_shop_top .quick-svg',function(e){
  $(this).next().addClass('is-open');
});
$('body').on('click','.cl_shop_top .quick_popup_close',function(e){
  $(this).next().removeClass('is-open');
});

// product grid open inner popup
$('body').on('click','.cl_shop_add_on_wpr .quick-svg',function(e){
  $(this).next().addClass('is-open');
});
$('body').on('click','.cl_shop_add_on_wpr .quick_popup_close',function(e){
  $(this).next().removeClass('is-open');
});

// grid open in mobile
// $('body').on('click','.cl_category_slide_custom',function(e){
//   if ($(window).width() < 768) {
//     $(".cl_category_slide_custom").removeClass("is-open");
//     $(this).addClass("is-open");
//     $(this).parents(".cl_category_slider_col").find(".cl_category_product").slideDown();
//   }
// });


// shoop by look
$('body').on('click','.cl_shop_upside', function() {
  if ($(window).width() < 767) {
     if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $(this).parents('.cl_shop_category_block').find('.cl_shop_bottom,.product-form-addon').slideUp();
    } else {
      $(this).addClass('active');
      $(this).parents('.cl_shop_category_block').find('.cl_shop_bottom,.product-form-addon').slideDown();
    }
  }
});
var selectedValues = {};
$('body').on('click','.cl_carousel_info ul.gear_select_ul li a',function(e){
  e.preventDefault();
  
  var cur_filter = $(this).parents('.cl_info_slide_inner').find('.activity_btn').text();
  var tab_txt = $(this).text();
  var tab_txt_val = $(this).attr('data-val');
  var data_filter_group = $(this).attr('data-filter-group');
  $(this).parents('.activity_btns_wpr').find('a.activity_btn').text(tab_txt);
  var cur_tab = $(this).parents('.carousel-cell').attr('data-tab');
  $('.cl_carousel_col.'+cur_tab).addClass('select_tab_val').find('h6').text(tab_txt);
  $(this).parents('.cl_border_mob').addClass('val_added').find('.cl_carousel_mob_title h4').text(tab_txt);
  if (data_filter_group){
    var arr = $('.thb-filter[data-tab="'+ cur_tab +'"] input[data-value="'+ data_filter_group +'"]').attr('data-filter-url');
  }else{
     var arr = $('.thb-filter[data-tab="'+ cur_tab +'"] input[data-value="'+ tab_txt_val +'"]').attr('data-filter-url');
   }
  var name = $(this).parents('.gear_select_ul').attr('data-name');
  // Update the selectedValues object
  selectedValues[name] = arr;
   // Construct the URL with the selected values
    var queryParams = Object.values(selectedValues).join('&');
    var url = window.location.origin + window.location.pathname + '?' + queryParams;
    var steps_count = parseInt($('.cl_carousel_col.select_tab_val').length);
    var steps_cot = parseInt($('.cl_carousel_col').length);
    // if(steps_count == steps_cot){  
    //    $('.step_error').hide();
    //     var paramsup = {
    //       type: 'GET',
    //       url: url,
    //       success: function(data) { 
    //         window.history && window.history.pushState && window.history.pushState("", "", url);
    //         var grid = $(data).find('#ProductGridContainer').html();
    //         $('#ProductGridContainer').html(grid);
    //       },
    //       error: function() {
    //       }
    //     };
    //   $.ajax(paramsup);
    // }else{
    //     $('.step_error').text('Please fill out all the steps').show();
    // }
   // $('.step_error').hide();
   //      var paramsup = {
   //        type: 'GET',
   //        url: url,
   //        success: function(data) { 
   //          window.history && window.history.pushState && window.history.pushState("", "", url);
   //          var grid = $(data).find('#ProductGridContainer').html();
   //          $('#ProductGridContainer').html(grid);
   //        },
   //        error: function() {
   //        }
   //      };
   //    $.ajax(paramsup);

  // Function to handle the AJAX request
var paramsup = {
  method: 'GET',
  url: url, // URL to request the data from
  success: function(data) {
    // Update the browser URL if pushState is available
    if (window.history && window.history.pushState) {
      window.history.pushState("", "", url);
    }

    // Create a temporary DOM element to parse the HTML response
    var parser = new DOMParser();
    var doc = parser.parseFromString(data, 'text/html');
    var grid = doc.querySelector('#ProductGridContainer').innerHTML; // Extract the HTML content for the product grid
    
    // Replace the content of the ProductGridContainer
    var productGridContainer = document.querySelector('#ProductGridContainer');
    productGridContainer.innerHTML = grid; // Replace the existing content
  },
  error: function() {
    console.error("Error loading the content.");
  }
};

// Create the XMLHttpRequest object
var xhr = new XMLHttpRequest();
xhr.open(paramsup.method, paramsup.url, true);

// Set up the callback function
xhr.onload = function() {
  if (xhr.status === 200) {
    paramsup.success(xhr.responseText);
  } else {
    paramsup.error();
  }
};

// Send the request
xhr.send();

    return false;
  
});

  $('body').on('change','.cl_carousel_info .visor_option_col input',function(e){
    e.preventDefault();
    var cur_tab = $(this).parents('.carousel-cell').attr('data-tab');
    var pre_val = $('.cl_carousel_col.select_tab_val.'+cur_tab).find('h6').text();
    var tab_txt = $(this).val();    
    var tab_txt_val = $(this).attr('data-val');
    $('.cl_carousel_col.'+cur_tab).addClass('select_tab_val').find('h6').text(tab_txt);
    
    var arr = $('.thb-filter[data-tab="'+ cur_tab +'"] input[data-value="'+ tab_txt_val +'"]').attr('data-filter-url');
    var name = $(this).parents('.visor_option_inn').attr('data-name');
    selectedValues[name] = arr;
    
    // Construct the URL with the selected values
    var queryParams = Object.values(selectedValues).join('&');
    var url = window.location.origin + window.location.pathname + '?' + queryParams;
    var steps_count = parseInt($('.cl_carousel_col.select_tab_val').length);
    var steps_cot = parseInt($('.cl_carousel_col').length);
    // if(steps_count == steps_cot){  
    //   $('.step_error').hide();
    //     var paramsup = {
    //       type: 'GET',
    //       url: url,
    //       success: function(data) { 
    //         window.history && window.history.pushState && window.history.pushState("", "", url);
    //         var grid = $(data).find('#ProductGridContainer').html();
    //         $('#ProductGridContainer').html(grid);
    //       },
    //       error: function() {
    //       }
    //     };
    //   $.ajax(paramsup);
    // }else{
    //     $('.step_error').text('Please fill out all the steps').show();
    // }
     $('.step_error').hide();
       // Function to handle the AJAX request
var paramsup = {
  method: 'GET',
  url: url, // URL to request the data from
  success: function(data) {
    // Update the browser URL if pushState is available
    if (window.history && window.history.pushState) {
      window.history.pushState("", "", url);
    }

    // Create a temporary DOM element to parse the HTML response
    var parser = new DOMParser();
    var doc = parser.parseFromString(data, 'text/html');
    var grid = doc.querySelector('#ProductGridContainer').innerHTML; // Extract the HTML content for the product grid
    
    // Replace the content of the ProductGridContainer
    var productGridContainer = document.querySelector('#ProductGridContainer');
    productGridContainer.innerHTML = grid; // Replace the existing content
  },
  error: function() {
    console.error("Error loading the content.");
  }
};

// Create the XMLHttpRequest object
var xhr = new XMLHttpRequest();
xhr.open(paramsup.method, paramsup.url, true);

// Set up the callback function
xhr.onload = function() {
  if (xhr.status === 200) {
    paramsup.success(xhr.responseText);
  } else {
    paramsup.error();
  }
};

// Send the request
xhr.send();

    return false;
});

$('body').on('change', '.thb-filter-sort .sortby-filter', function(e) {
  var sort_value = $(this).val();
  $('.sortby-filter').not(this).prop('checked', false); 
});

var swiper = new Swiper(".category_sliders", {
  slidesPerView: 2,
  spaceBetween: 8,
  navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
     clickable: true
  },
  breakpoints: {
    1024: {
      slidesPerView: 4,
      spaceBetween: 15,
    },
    767: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
});

(function () {
  if (!document.body.classList.contains('template-page-guide-bike-helmets')) return;

  function initGuideLayout() {
    var mainContent = document.getElementById('main-content');
    if (!mainContent) return;

    // Don't run twice
    if (mainContent.querySelector('.guide-two-col-wrapper')) return;

    var allSections = Array.from(mainContent.children);

    var heroSection = allSections.find(function (s) {
      return s.querySelector('.guide-hero');
    });
    var introSection = allSections.find(function (s) {
      return s.querySelector('.guide-intro');
    });
    var tocSection = allSections.find(function (s) {
      return s.querySelector('#guide-toc');
    });

    if (!tocSection) return;

    var contentSections = allSections.filter(function (s) {
      return s !== heroSection && s !== introSection && s !== tocSection;
    });

    if (contentSections.length === 0) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'guide-two-col-wrapper';

    var tocCol = document.createElement('div');
    tocCol.className = 'guide-two-col-toc';
    tocCol.appendChild(tocSection);

    var contentCol = document.createElement('div');
    contentCol.className = 'guide-two-col-content';
    contentSections.forEach(function (s) {
      contentCol.appendChild(s);
    });

    wrapper.appendChild(tocCol);
    wrapper.appendChild(contentCol);

    var insertAfter = introSection || heroSection;
    if (insertAfter && insertAfter.nextSibling) {
      mainContent.insertBefore(wrapper, insertAfter.nextSibling);
    } else {
      mainContent.appendChild(wrapper);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGuideLayout);
  } else {
    initGuideLayout();
  }

})();